import React from "react";
import Helmet from "react-helmet";
import { SEO } from "@fishrmn/fishrmn-components";
import { socialMediaTypes } from "@fishrmn/fishrmn-types";

import config from "../../config/config";

import InstagramDisplay from "../components/InstagramDisplay/";
import InstagramQuery from "../components/InstagramQuery";

const locationInfo = [
  {
    city: "Denver - LoDo/Union Station",
    address: "1735 Chestnut Place, Denver, CO 80202",
    hours: [
      "Monday - Friday: 7am - 6pm",
      "Saturday - Sunday: 7:30am - 6pm"
    ],
    phone: "(720) 372-7862",
    orderOnlineLink:
      "https://www.ubereats.com/store/whole-sol-blend-bar-lodo/WaRh1OevS964-f_mkBHHeA?pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkRlbnZlciUyMFVuaW9uJTIwU3RhdGlvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMjZmYzc4NzAwLTM0Y2QtM2IyOS05MDRlLWM5MmMxNzBiODRkYSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJ1YmVyX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBMzkuNzUzMTQyOSUyQyUyMmxvbmdpdHVkZSUyMiUzQS0xMDUuMDAwMTUzOSU3RA%3D%3D"
  },
  {
    city: "Boulder - Twenty Ninth Street Mall",
    address: "1810 29th St #1087, Boulder, CO 80301",
    hours: [
      "Monday - Thursday: 8am - 6pm",
      "Friday - Sunday: 7am - 7pm"
    ],
    phone: "(303) 209-7477",
    orderOnlineLink:
      "https://www.ubereats.com/store/whole-sol-blend-bar-twenty-ninth-street/-VJ_LcUPSXW0kAlLaFi3Gg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkRlbnZlciUyMFVuaW9uJTIwU3RhdGlvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMjZmYzc4NzAwLTM0Y2QtM2IyOS05MDRlLWM5MmMxNzBiODRkYSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJ1YmVyX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBMzkuNzUzMTQyOSUyQyUyMmxvbmdpdHVkZSUyMiUzQS0xMDUuMDAwMTUzOSU3RA%3D%3D"
  },
  {
    city: "Denver - Tabor Center - Now Open!",
    address: "1200 17th St Suite 150, Denver, CO 80202",
    hours: ["Monday - Friday 7am - 3pm"],
    phone: "303-954-9419",
    orderOnlineLink: "https://www.ubereats.com/store/whole-sol-blend-bar-tabor-center/_znCwUyaWdaxZIEY5LNCLA?diningMode=DELIVERY"
  },
  // {
  //   city: "Longmont, CO - Coming Soon (Spring 2023)",
  //   address: "645 Tenacity Drive, Longmont, CO 80504",
  //   hours: [],
  //   phone: ""
  // }
];

export default () => (
  <div id="locations">
    <SEO
      config={config}
      path={config.baseConfig.pageMetadata.locations.path}
      title={config.baseConfig.pageMetadata.locations.title}
      description={config.baseConfig.pageMetadata.locations.description}
      smTypes={[socialMediaTypes.facebook, socialMediaTypes.twitter]}
    />
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org/",
          "@type": "LocalBusiness",
          name: "Whole Sol",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4.7",
            ratingCount: "106"
          }
        })}
      </script>
    </Helmet>
    <div id="locations-background">
      <div id="locations-overlay">
        <h1 id="locations-title">WHOLE SOL LOCATIONS</h1>
        <div>
          <div className="location-info">
            <a
              href="https://www.google.com/maps/place/1735+Chestnut+Pl,+Denver,+CO+80202/@39.7556528,-105.0041489,17z/data=!3m1!4b1!4m5!3m4!1s0x876c78c26b8442d7:0xd2927d3cd07eee5!8m2!3d39.7556528!4d-105.0019602"
              target="_blank"
              rel="noopener"
            >
              <h2>{locationInfo[0].city}</h2>
              <h3>{locationInfo[0].address}</h3>
            </a>
            <a href={`tel:${locationInfo[0].phone}`}>
              <h3>{locationInfo[0].phone}</h3>
            </a>
            <div>
              <span>Hours</span>
              <span>
                {locationInfo[0].hours.map(hourItem => (
                  <div key={hourItem}>{hourItem}</div>
                ))}
              </span>
            </div>
            <div id="locations-buttons-container">
              <div>
                <a
                  href={locationInfo[0].orderOnlineLink}
                  target="_blank"
                  rel="noopener"
                >
                  <button id="online-order-button">ORDER DELIVERY</button>
                  <div id="online-order-button-desc">
                    Delivery provided by Uber Eats, Whole Sol's exclusive
                    delivery partner.{" "}
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="location-info">
            <a
              href="https://www.google.com/maps/place/3605+Walnut+St,+Denver,+CO+80205/@39.7689823,-104.9765406,17z/data=!3m1!4b1!4m6!3m5!1s0x876c791aa0734f4b:0x356f36fab6d5e6ff!8m2!3d39.7689782!4d-104.9739603!16s%2Fg%2F11ljb0xbg4?entry=ttu"
              target="_blank"
              rel="noopener"
            >
              <h2>{locationInfo[1].city}</h2>
              <h3>{locationInfo[1].address}</h3>
            </a>
            <a href={`tel:${locationInfo[1].phone}`}>
              <h3>{locationInfo[1].phone}</h3>
            </a>
            <div>
              <span>Hours</span>
              <span>
                {locationInfo[1].hours.map(hourItem => (
                  <div key={hourItem}>{hourItem}</div>
                ))}
              </span>
            </div>
            <div id="locations-buttons-container">
              <div>
                <a
                  href={locationInfo[1].orderOnlineLink}
                  target="_blank"
                  rel="noopener"
                >
                  <button id="online-order-button">ORDER DELIVERY</button>
                  <div id="online-order-button-desc">
                    Delivery provided by Uber Eats, Whole Sol's exclusive
                    delivery partner.{" "}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="location-info">
            <a
              href="https://www.google.com/maps/place/Tabor+Center/@39.7488148,-104.9965355,15z/data=!4m2!3m1!1s0x0:0x2b4a50db8be673de?sa=X&ved=2ahUKEwjlvKrN5uj7AhVhhXIEHVqmAGIQ_BJ6BAhlEAg"
              target="_blank"
            >
              <h2>{locationInfo[2].city}</h2>
              <h3>{locationInfo[2].address}</h3>
            </a>
            <a href={`tel:${locationInfo[2].phone}`}>
              <h3>{locationInfo[2].phone}</h3>
            </a>
            <div>
              <span>Hours</span>
              <span>
                {locationInfo[2].hours.map(hourItem => (
                  <div key={hourItem}>{hourItem}</div>
                ))}
              </span>
            </div>
            <div id="locations-buttons-container">
              <div>
                <a
                  href={locationInfo[2].orderOnlineLink}
                  target="_blank"
                  rel="noopener"
                >
                  <button id="online-order-button">ORDER DELIVERY</button>
                  <div id="online-order-button-desc">
                    Delivery provided by Uber Eats, Whole Sol's exclusive
                    delivery partner.{" "}
                  </div>
                </a>
              </div>
            </div>
          </div>
          {/*<div className="location-info">*/}
            {/*<a*/}
              {/*href="https://www.google.com/maps/place/Whole+Sol+Blend+Bar+-+Juice+Bar+%26+Smoothies+-+Twenty+Ninth+Street/@40.0185523,-105.2554575,15z/data=!4m6!3m5!1s0x876bed2f9c9d39f5:0x37589b688563cb24!8m2!3d40.0177241!4d-105.2561988!16s%2Fg%2F11kx0f36fd?entry=ttu"*/}
              {/*target="_blank"*/}
            {/*>*/}
              {/*<h2>{locationInfo[3].city}</h2>*/}
              {/*<h3>{locationInfo[3].address}</h3>*/}
            {/*</a>*/}
            {/*<a href={`tel:${locationInfo[3].phone}`}>*/}
              {/*<h3>{locationInfo[3].phone}</h3>*/}
            {/*</a>*/}
            {/*<div>*/}
              {/*<span>Hours</span>*/}
              {/*<span>*/}
                {/*{locationInfo[3].hours.map(hourItem => (*/}
                  {/*<div key={hourItem}>{hourItem}</div>*/}
                {/*))}*/}
              {/*</span>*/}
            {/*</div>*/}
            {/*<div id="locations-buttons-container">*/}
              {/*<div>*/}
                {/*<a*/}
                  {/*href={locationInfo[3].orderOnlineLink}*/}
                  {/*target="_blank"*/}
                  {/*rel="noopener"*/}
                {/*>*/}
                  {/*<button id="online-order-button">ORDER DELIVERY</button>*/}
                  {/*<div id="online-order-button-desc">*/}
                    {/*Delivery provided by Uber Eats, Whole Sol's exclusive*/}
                    {/*delivery partner.{" "}*/}
                  {/*</div>*/}
                {/*</a>*/}
              {/*</div>*/}
            {/*</div>*/}
          {/*</div>*/}
        </div>
        {/*<div>*/}
          {/*<div className="location-info">*/}
            {/*<a*/}
              {/*href="https://www.google.com/maps/place/Tabor+Center/@39.7488148,-104.9965355,15z/data=!4m2!3m1!1s0x0:0x2b4a50db8be673de?sa=X&ved=2ahUKEwjlvKrN5uj7AhVhhXIEHVqmAGIQ_BJ6BAhlEAg"*/}
              {/*target="_blank"*/}
            {/*>*/}
              {/*<h2>{locationInfo[4].city}</h2>*/}
              {/*<h3>{locationInfo[4].address}</h3>*/}
            {/*</a>*/}
            {/*<a href={`tel:${locationInfo[4].phone}`}>*/}
              {/*<h3>{locationInfo[4].phone}</h3>*/}
            {/*</a>*/}
            {/*<div>*/}
            {/*<span>Hours</span>*/}
            {/*<span>*/}
            {/*{locationInfo[4].hours.map(hourItem => (*/}
            {/*<div key={hourItem}>{hourItem}</div>*/}
            {/*))}*/}
            {/*</span>*/}
            {/*</div>*/}
            {/*<div id="locations-buttons-container">*/}
            {/*<div>*/}
            {/*<a*/}
            {/*href="https://www.ubereats.com/store/whole-sol-blend-bar-tabor-center/_znCwUyaWdaxZIEY5LNCLA?diningMode=DELIVERY"*/}
            {/*target="_blank"*/}
            {/*rel="noopener"*/}
            {/*>*/}
            {/*<button id="online-order-button">ORDER DELIVERY</button>*/}
            {/*<div id="online-order-button-desc">*/}
            {/*Delivery provided by Uber Eats, Whole Sol's exclusive*/}
            {/*delivery partner.{" "}*/}
            {/*</div>*/}
            {/*</a>*/}
            {/*</div>*/}
            {/*</div>*/}
          {/*</div>*/}
          {/*<div className="location-info">*/}
            {/*<a*/}
              {/*href="https://www.google.com/maps/place/1208+W+Elizabeth+St,+Fort+Collins,+CO+80521/data=!4m2!3m1!1s0x87694a4610be1f53:0x933ffceb0cf9e184?sa=X&ved=2ahUKEwiv2Pbi5IL4AhVYQzABHWiYAw0Q8gF6BAgNEAE"*/}
              {/*target="_blank"*/}
            {/*>*/}
              {/*<h2>{locationInfo[5].city}</h2>*/}
              {/*<h3>{locationInfo[5].address}</h3>*/}
            {/*</a>*/}
            {/*<div />*/}
            {/*/!*<a href={`tel:${locationInfo[4].phone}`}>*!/*/}
            {/*/!*<h3>{locationInfo[4].phone}</h3>*!/*/}
            {/*/!*</a>*!/*/}
            {/*<div>*/}
            {/*/!*<span>Hours</span>*!/*/}
            {/*/!*<span>*!/*/}
            {/*/!*{locationInfo[5].hours.map(hourItem => (*!/*/}
            {/*/!*<div key={hourItem}>{hourItem}</div>*!/*/}
            {/*/!*))}*!/*/}
            {/*/!*</span>*!/*/}
            {/*</div>*/}
            {/*<div id="locations-buttons-container">*/}
            {/*<div>*/}
            {/*<a*/}
            {/*href="https://www.order.store/store/whole-sol-blend-bar-west-elizabeth-street/g_DyZLc4Vz6z2p2qQ-NelA"*/}
            {/*target="_blank"*/}
            {/*rel="noopener"*/}
            {/*>*/}
            {/*<button id="online-order-button">ORDER DELIVERY</button>*/}
            {/*<div id="online-order-button-desc" style={{ fontWeight: 400 }}>*/}
            {/*Delivery provided by Uber Eats, Whole Sol's exclusive*/}
            {/*delivery partner.{" "}*/}
            {/*</div>*/}
            {/*</a>*/}
            {/*</div>*/}
            {/*</div>*/}
          {/*</div>*/}
        {/*</div>*/}
      </div>
    </div>
    <div>
      <InstagramQuery>
        {imageURLs => <InstagramDisplay imageURLs={imageURLs} />}
      </InstagramQuery>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/locations.jsx